"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerCompanyDetailPageActions;
(function (CustomerCompanyDetailPageActions) {
    CustomerCompanyDetailPageActions["Loaded"] = "Loaded";
})(CustomerCompanyDetailPageActions || (CustomerCompanyDetailPageActions = {}));
exports.default = CustomerCompanyDetailPageActions;
